module.exports = __webpack_public_path__ + "img/package3.90e1b6d6.png";